import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { prefixClassName } from '../../util/scopeClassName.js';
import { all } from 'deepmerge';

var mergeTheme = function mergeTheme(obj1, obj2) {
  return all([obj1, obj2]);
};
function mergeThemeExperiment(theme, subThemes) {
  var className = prefixClassName(theme.name);
  var _reduce = (theme.subThemes ? Object.values(subThemes) : []).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        isB = _ref2[1];
      var _acc = _slicedToArray(acc, 2),
        themeAcc = _acc[0],
        classNameAcc = _acc[1];
      var subTheme = theme.subThemes[name];
      if (!isB || !subTheme) return acc;
      var mergedTheme = mergeTheme(themeAcc, subTheme);
      mergedTheme.name = theme.name;
      return [mergedTheme, "".concat(classNameAcc, " ").concat(className, "-").concat(name)];
    }, [theme, className]),
    _reduce2 = _slicedToArray(_reduce, 2),
    newTheme = _reduce2[0],
    newClassName = _reduce2[1];
  return [newTheme, newClassName];
}

export { mergeThemeExperiment };
//# sourceMappingURL=ThemeExperiment.js.map
